import { render } from "./old-community-home.vue?vue&type=template&id=04da7dee&scoped=true&ts=true"
import script from "./old-community-home.vue?vue&type=script&lang=ts"
export * from "./old-community-home.vue?vue&type=script&lang=ts"

import "./old-community-home.vue?vue&type=style&index=0&id=04da7dee&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04da7dee"]])

export default __exports__